<mat-progress-spinner
  class="track"
  [diameter]="diameter"
  [strokeWidth]="strokeWidth * 0.9875"
  color="primary"
  mode="determinate"
  value="100"
  aria-hidden="true"
/>
<mat-progress-spinner
  class="progress"
  [diameter]="diameter"
  [strokeWidth]="strokeWidth"
  [value]="progress"
  [attr.aria-label]="ariaLabel"
  color="accent"
  mode="determinate"
/>
